
import * as api from './api';
import { CrudApiService, CrudServiceProps } from "../ApiCrudService";

export const AdapterDefCrudService = function(props: 
  CrudServiceProps<api.AdapterDef,string>
) {
  
  return CrudApiService<api.AdapterDef,string>({...props, api: api, entityName: 'AdapterDef'});

};